import ProfileArchetypesSection from './ProfileArchetypesSection'

export default ProfileArchetypesSection
export type { ProfileArchetypesSectionProps } from './ProfileArchetypesSection'
